import { render, staticRenderFns } from "./AddNewSchool.Dialog.vue?vue&type=template&id=5c610576"
import script from "./AddNewSchool.Dialog.vue?vue&type=script&lang=js"
export * from "./AddNewSchool.Dialog.vue?vue&type=script&lang=js"
import style0 from "./AddNewSchool.Dialog.vue?vue&type=style&index=0&id=5c610576&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports